import  styled  from 'styled-components';
import { Paper as MuiPaper } from '@mui/material';

export const StyledPaper = styled(MuiPaper)`
  padding: 2rem;
  border-radius: ${({rounded}) => rounded ? '16px !important' : '4px'};
`;